import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminResendMsg = (chatID) => {
  return axiosClient.get(`/api/admin/im/unread/${chatID}`).then((r) => r.data);
};
